<template>
	<shop-root-component />
</template>

<script>
	import appConfig from "../../../appconfig";
	import {GATHER_EVALUATION_TAG_DATA} from "../../../store/mutation-types";

	export default {
		name: "ShopRoot",
		components: {
			ShopRootComponent: () => {
				switch (appConfig.globalTemplateName) {
				case "gt2":
					return import("../../ShopComponents/gt2/GlobalTemplateRoot-gt2");
				case "gt3":
					return import("../../ShopComponents/gt3/GlobalTemplateRoot-gt3");
				case "gtDemo":
					return import("../../ShopComponents/gtDemo/GlobalTemplateRoot-gtDemo");
				default:
					return import("../../ShopComponents/defaultGlobalTemplate/GlobalTemplateRoot");
				}
			}
		},
		async created() {
			await this.$store.dispatch(GATHER_EVALUATION_TAG_DATA);
		}
	};
</script>
